import { useEffect, useState } from "react";

export const useGetUserData = () => {
  const [userData, setUserData] = useState({});
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setUserData(user);
  }, []);
  return userData;
};
